<template>
  <qz-results-details
    :quote="quote"
    :qd="quoteDetails"
    :is-view-monthly="isViewMonthly"
    :is-buy-online-disabled="isBuyOnlineDisabled"
    :details-description="detailsDescription"
    :selected-optional-extras="selectedOptionalExtras"
    :is-details-drawer-open="isDetailsDrawerOpen"
    :product-name="productName"
    :filter-extras="filterExtras"
    :good-to-know-options="['covered', 'notAvailable']"
    :is-info-note-shown="false"
    :quote-position-number="quotePositionNumber"
    @go-to-form="$emit('go-to-form')"
    @close-drawer="$emit('close-drawer')"
    @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
  >
    <template #cover-and-excess>
      <div class="mt-3">
        <h4 class="font-weight-bold mb-3">Vets fee cover & excess</h4>
        <p class="mb-0 font-weight-bold">Vet Fee Limits -</p>
        <p>{{ coverTypeLabel }} <strong>{{ helpers.getExtrasPrice(quoteDetails.optionalExtra.vetsFee) }}</strong> {{ quoteDetails.optionalExtra.vetsFee.suffix || '' }}</p>
        <p>Annual Policy Limit: <strong>{{ helpers.getExtrasPrice(quoteDetails.optionalExtra.annualPolicyLimit) }}</strong></p>
        <p>Cover Time Limit: <strong>{{ helpers.getExtrasPrice(quoteDetails.optionalExtra.coverTimeLimit, true) }}</strong></p>
        <p class="mb-0">Vet Excess: <span class="font-weight-bold">{{ helpers.getExtrasPrice(quoteDetails.optionalExtra.vetExcess) }}</span></p>
        <p>{{ quoteDetails.optionalExtra.vetExcess.description }} {{ quoteDetails.compulsoryExtraText }}</p>
      </div>
    </template>

    <template #breakdown-top>
      <p class="text-center fs-12">Cover type: <strong>{{ coverType }}</strong></p>
    </template>

    <template #policy-excess>
      <div>
        <p><strong>{{ coverType }}</strong> cover type:</p>
        <p
          v-for="(line, index) in coverTypeDescription"
          :key="index"
          class="caption"
        >
          {{ line }}
        </p>
      </div>
    </template>
  </qz-results-details>
</template>

<script>
import QzResultsDetails from '@/components/pet/Results/QzResultsDetails';
import { camelCase, isEmpty, startCase } from 'lodash';

export default {
  name: 'results-details',
  components: {
    QzResultsDetails,
  },
  inject: ['helpers'],
  props: {
    quote: {
      required: false,
      type: Object,
      default: undefined,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isDetailsDrawerOpen: {
      type: Boolean,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    coverTypeDetails: {
      type: Array,
      default: () => [],
    },
    coverTypeRelatedLabel: {
      type: String,
      default: '',
    },
    quotePositionNumber: {
      required: true,
      type: Number,
    },
  },
  data () {
    return {
      buyOnlineChecked: false,
    };
  },
  computed: {
    quoteDetails () {
      return this.quote?.details?.[0] || null;
    },
    coverTypeLabel () {
      return this.quoteDetails.optionalExtra.vetsFee.prefix || `${this.coverTypeRelatedLabel} Limit:`;
    },
    hasBuyOnline () {
      return this.quoteDetails?.isBuyOnlineCheckbox;
    },
    isBuyOnlineDisabled () {
      return (!this.buyOnlineChecked && this.hasBuyOnline);
    },
    coverTypeDescription () {
      return this.coverTypeDetails.find(item => item.name.toLowerCase() === this.quoteDetails.coverType.toLowerCase())?.description;
    },
    coverType () {
      const formattedCoverType = startCase(camelCase(this.quoteDetails.coverType));

      return formattedCoverType === 'Accidents Only' ? 'Accident Only' : formattedCoverType;
    },
  },
  methods: {
    filterExtras (condition) {
      const extras = Object.keys(this.quoteDetails.optionalExtra).reduce((acc, cover) => {
        if (
          this.quoteDetails.optionalExtra[cover].included === condition &&
          this.quoteDetails.optionalExtra[cover].description !== 'DO_NOT_SHOW'
        ) {
          return {
            ...acc,
            [cover]: this.quoteDetails.optionalExtra[cover],
          };
        }
        return acc;
      }, {});

      return isEmpty(extras) ? null : extras;
    },
  },
};
</script>
